import { AbstractAdapter } from './AbstractAdapter';
import { getWaleltProvider, SupportProviderFlag } from '../provider';
import type { EIP1193Provider } from '../provider';
type LegacyEip155AdapterOption = {
  isBitkeep?: boolean | undefined;
  debug?: boolean
};
class EIP1193Adapter extends AbstractAdapter {
  constructor(
    Options: LegacyEip155AdapterOption = {
      isBitkeep: true,
      debug: false
    }
  ) {
    super({
      providerFlag: SupportProviderFlag.EVM,
      isBitkeep: Options.isBitkeep,
      debug: Options.debug
    });
  }
  getProvider() {
    return getWaleltProvider<EIP1193Provider>(this.providerFlag) as EIP1193Provider;
  }
}

export { EIP1193Adapter };
export const LegacyEip1193Adapter = EIP1193Adapter